import { Segment } from 'semantic-ui-react';
import scrollTo from "../functions/scrollTo";
import { FavoriteResourceStar } from '../components/FavoriteResourcesPage';
import { NotificationBell } from '../components/NotificationsForResources';
import { useSelector } from 'react-redux';
import { selectGlobalLoading } from '../slices/globalLoading/globalLoadingSlice';
import { selectBottomNavigationElements, selectTopNavigationElements } from '../slices/navigationPanel/navigationPanelSlice';

const NavigationSegment = ({ resourceId, editor }) => {
    const siteIsLoading = useSelector(selectGlobalLoading);
    const topNavigationElements = useSelector(selectTopNavigationElements);
    const bottomNavigationElements = useSelector(selectBottomNavigationElements);
    const navigationElements = topNavigationElements.concat(bottomNavigationElements);

    if (navigationElements.length === 0) {
        return <>{(resourceId && !siteIsLoading) && <>
                <NotificationBell resourceId={resourceId} editor={editor} absolutePosition={true}
                    topOffset={"-22px"} rightOffset={"8px"} />
                <FavoriteResourceStar resourceId={resourceId} absolutePosition={true}
                    topOffset={"-22px"} rightOffset={"-18px"} />
            </>}
        </>
    } else {
        return <Segment className={`containerSegment maxNavigationSegment unselectable`}
            style={{ marginTop: "8px", paddingTop: "1px", paddingBottom: "6px" }} raised>
            <h2 style={{
                fontSize: "20px", marginTop: "0px",
                marginBottom: "0px", textAlign: "center"
            }}>Navigation</h2>
            {resourceId && <>
                <NotificationBell resourceId={resourceId} editor={editor} absolutePosition={true} />
                <FavoriteResourceStar resourceId={resourceId} absolutePosition={true} />
            </>}
            <div className={`navigationLinksSection`} style={{ paddingTop: "4px", textAlign: "left" }}>
                {navigationElements.map((element, index) => {
                    let id = "";
                    if (index != 0) {
                        id = element.toLowerCase().replace(/\s/g, "-").replace(/\//g, "-");
                    }
                    return <span key={index}>
                        <a onClick={() => scrollTo("resourceTextViewSegment", id, true)} >{element}</a>
                        {index !== navigationElements.length - 1 && <><br /><div style={{ height: "4px" }} /></>}
                    </span>
                })}
            </div>
        </Segment>
    }
}
export default NavigationSegment;